export const alphaNumericRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9 -]*[a-zA-Z0-9])?$/;
export const addressUsZipRegEx = /^\s*\d{5}(?:-\d{4})?\s*$/;
export const zipIsRequired = "ZIP / Postal code is required";
export const usZipSyntaxError = "ZIP / Postal code must have format ##### or #####-####";
export const alphanumericError = "Must contain only alpha-numeric characters and spaces";
